/**
 * Search template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

const NAME = 'Search';

const init = () => {
  Logger.info(`${NAME} > init`);
  initFilterToggles();
  initFilterForms();
}

const initFilterToggles = () => {
  document.querySelectorAll('[data-filter-root]').forEach(root => {
    const toggle = root.querySelector('[data-filter-toggle]')
    const panel = root.querySelector('[data-filter-panel]')

    if (!toggle || !panel) {
      return
    }

    toggle.addEventListener('click', () => {
      const isOpen = panel.dataset.open === 'true'
      panel.dataset.open = isOpen ? 'false' : 'true'
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true')
    })
  })
}

const measureSelectTextWidth = (select, label) => {
  const canvas = measureSelectTextWidth.canvas || (measureSelectTextWidth.canvas = document.createElement('canvas'))
  const context = canvas.getContext('2d')

  if (!context) {
    return null
  }

  const styles = window.getComputedStyle(select)
  context.font = `${styles.fontWeight} ${styles.fontSize} ${styles.fontFamily}`

  return context.measureText(label).width
}

const syncSelectWidths = (form) => {
  form.querySelectorAll('select').forEach(select => {
    const selectedOption = select.options[select.selectedIndex]
    const label = selectedOption?.textContent?.trim() || ''
    const textWidth = measureSelectTextWidth(select, label)

    if (textWidth) {
      select.style.width = `${Math.ceil(textWidth + 18)}px`
      return
    }

    const width = Math.max(label.length + 0.75, 4)
    select.style.width = `${width}ch`
  })
}

const decodeSearchQuery = (value) => {
  const textarea = decodeSearchQuery.textarea || (decodeSearchQuery.textarea = document.createElement('textarea'))
  let nextValue = String(value || '').trim()

  for (let index = 0; index < 4; index += 1) {
    textarea.innerHTML = nextValue
    const decodedValue = textarea.value

    if (decodedValue === nextValue) {
      break
    }

    nextValue = decodedValue
  }

  return nextValue
}

const cleanSearchQuery = (value) =>
  decodeSearchQuery(value).replace(/"/g, '').trim()

const syncSearchQueryForType = (form) => {
  const queryInput = form.querySelector('[data-search-query-input]')
  const typeSelect = form.querySelector('select[name="type"]')

  if (!queryInput) {
    return
  }

  const cleanQuery = cleanSearchQuery(queryInput.dataset.searchQuery || queryInput.value)
  const productQuery = `"${cleanQuery}"`

  queryInput.dataset.searchQuery = cleanQuery
  queryInput.dataset.productSearchQuery = productQuery
  queryInput.value = typeSelect?.value === 'product'
    ? productQuery
    : cleanQuery
}

const initFilterForms = () => {
  document.querySelectorAll('[data-filter-form]').forEach(form => {
    const statuses = Array.from(form.closest('[data-filter-root]')?.querySelectorAll('[data-filter-status]') || [])
    const defaultStatusText = statuses[0] ? statuses[0].textContent.trim() : ''
    const typeSelect = form.querySelector('select[name="type"]')

    const setLoadingState = () => {
      form.dataset.loading = 'true'
      form.setAttribute('aria-busy', 'true')

      statuses.forEach(status => {
        status.textContent = 'Updating...'
      })
    }

    syncSelectWidths(form)

    if (form.hasAttribute('data-loading-status')) {
      form.addEventListener('submit', () => {
        syncSearchQueryForType(form)
        setLoadingState()
      })
    }

    form.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', () => {
        syncSelectWidths(form)

        if (form.hasAttribute('data-loading-status')) {
          if (select === typeSelect && select.value === '') {
            setLoadingState()
            const url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin)
            const queryInput = form.querySelector('[data-search-query-input]')
            const q = cleanSearchQuery(queryInput?.dataset.searchQuery || queryInput?.value)

            if (q) {
              url.searchParams.set('q', q)
            }

            url.searchParams.set('options[prefix]', 'last')
            url.searchParams.set('options[unavailable_products]', 'show')
            window.location.href = `${url.pathname}${url.search}`
            return
          }

          statuses.forEach(status => {
            status.textContent = defaultStatusText
          })
          syncSearchQueryForType(form)
          setLoadingState()
          form.submit()
        }
      })
    })
  })
}

Global();
init();
Logger.log(`${NAME} > loaded`);
